import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5dc1bcec&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc1bcec')) {
      api.createRecord('5dc1bcec', component.options)
    } else {
      api.reload('5dc1bcec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5dc1bcec&", function () {
      api.rerender('5dc1bcec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/permission/index.vue"
export default component.exports